namespace $.$$ {

	$mol_style_define( $rise_devtools_selector_overlay_files, {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		alignItems: 'flex-start',

		Actions: {
			display: 'flex',
			gap: '4px',
		},

		Editor: {
			width: '760px',
			height: '420px',
			boxShadow: '0 12px 32px #0003',
		},

		Error: {
			maxWidth: '760px',
			padding: {
				top: '6px',
				right: '8px',
				bottom: '6px',
				left: '8px',
			},
			background: {
				color: '#d13f31',
			},
			color: 'white',
			font: {
				size: '12px',
				family: 'monospace',
			},
		},
	} )

}
